import { category } from '@/api'
import {
	CATEGORY_LOADING_STATUS,
	CATEGORY_FETCH_ERRORS,
	CATEGORY_FETCH,
	CATEGORY_SET,
	CATEGORY_DEFAULT_STRUCTURE,
} from './types'

const fetchCategories = async (ctx) => {
	ctx.commit(CATEGORY_LOADING_STATUS, true)
	try {
		const { data } = await category.fetchCategories()
		ctx.commit(CATEGORY_FETCH, data)
		ctx.commit(CATEGORY_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(CATEGORY_FETCH_ERRORS, e)
		console.error(e)
	}
}

const setCategory = async (ctx, payload) => {
	ctx.commit(CATEGORY_SET, payload)
}

const setDefaultStructure = ({commit}) => {
	try {
		commit(CATEGORY_DEFAULT_STRUCTURE)
	}
	catch (e) {
		console.error(e)
	}
}

export default {
	fetchCategories,
	setCategory,
	setDefaultStructure
}
